import axios from 'axios';
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { urlMarcacion } from '../app/EndPoints';
import { Employee } from '../app/types';

interface CameraViewProps { 
  employee: Employee;
  onBack: () => void;
  email:string;
  onReload: () => void;
}

const CameraView: React.FC<CameraViewProps> = ({ employee, onBack, email, onReload }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [isTaking, setisTaking] = useState(false);

  const startCamera = useCallback(async () => {
    try {
      setCapturedImage(null);
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
      setError(null);
    } catch (err) {
      console.error("Error accessing camera:", err);
      setError("No se pudo acceder a la cámara. Asegúrate de haber otorgado los permisos.");
    }
  }, []);

  useEffect(() => {
    startCamera();

    return () => {
      stream?.getTracks().forEach(track => track.stop());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCapture = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      if (context) {
        // Flip the image horizontally
        context.translate(canvas.width, 0);
        context.scale(-1, 1);
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL('image/jpeg');
        setCapturedImage(imageDataUrl);
        stream?.getTracks().forEach(track => track.stop());
      }
    }
  };
  
  const handleConfirm = async () => {
    if (capturedImage) {
      try {

        setisTaking(true)
        
        let fecha = new Date();
        let año = fecha.getFullYear();
        let mes = String(fecha.getMonth() + 1).padStart(2, '0');
        let dia = String(fecha.getDate()).padStart(2, '0');
        let horas = String(fecha.getHours()).padStart(2, '0');
        let minutos = String(fecha.getMinutes()).padStart(2, '0');
        let segundos = '00';
        let horaActual = `${año}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;

        // Paso 1: Enviar datos del registro
        let jsonData = {
          idemployee: employee.Id,
          mode: employee.Status,
          idattendance : employee.IdAttendance,
          time: horaActual,        
        };
        
        console.log(jsonData)

        let response = await axios.post(urlMarcacion, jsonData);
        let idmarcacion = response.data; 
        if (!idmarcacion) {
          console.error('No se recibió idmarcacion desde el backend');
          return;
        }

        // Paso 2: Subir imagen con el idmarcacion y hora
        const blob = dataURLtoBlob(capturedImage);

        const formData = new FormData();
        formData.append('photo', blob, idmarcacion + '.jpg');     
        formData.append('name', employee.Name);
        formData.append('time', horaActual);
        formData.append('mode', employee.Status.toString());
        formData.append('id', idmarcacion);       
        formData.append('email', email);       
        

        const uploadResponse = await axios.post(urlMarcacion + 'upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        console.log('Foto subida con éxito');
        onReload()
        setisTaking(false)
        onBack()
      } catch (error) {
        setisTaking(false)
        console.error('ERROR:', error);
      }
    }
  };


  // Función para convertir base64 a Blob
  function dataURLtoBlob(dataURL: string) {
    const arr = dataURL.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }



  if (error) {
    return (
      <div className="p-6 text-center text-error dark:text-dark-error">
        <p>{error}</p>
        <button onClick={onBack} className="mt-4 bg-secondary-container dark:bg-dark-secondary-container text-on-secondary-container dark:text-dark-on-secondary-container font-bold py-2 px-4 rounded-full">Volver</button>
      </div>
    );
  }

  return (
    <div className="p-4">
        <div className="relative w-full aspect-square bg-black rounded-2xl overflow-hidden">
            {capturedImage ? (
                <img src={capturedImage} alt="Captured" className="w-full h-full object-cover" />
            ) : (
              <>
                <video ref={videoRef} autoPlay playsInline className="w-full h-full object-cover transform -scale-x-100"></video>                
              </>                
            )}
            <canvas ref={canvasRef} className="hidden"></canvas>
        </div>
        {!isTaking ?
          <div className="mt-4 flex flex-col space-y-2">
              {capturedImage ? (
                  <>
                      <button onClick={handleConfirm} className="w-full bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary font-bold py-3 px-4 rounded-full hover:shadow-lg transition-shadow">Confirmar Foto</button>
                      <button onClick={startCamera} className="w-full border border-outline dark:border-dark-outline text-primary dark:text-dark-primary font-bold py-3 px-4 rounded-full hover:bg-primary/10 transition-colors">Tomar de Nuevo</button>
                  </>
              ) : (
                  <button onClick={handleCapture} className="w-full bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary font-bold py-3 px-4 rounded-full hover:shadow-lg transition-shadow">Capturar Foto</button>
              )}
              <button onClick={onBack} className="w-full text-primary dark:text-dark-primary font-bold py-3 px-4 rounded-full hover:bg-primary/10 transition-colors">Cancelar</button>
          </div>
        :
          <div className="mt-4 flex flex-col space-y-2">
            <h1 className="text-lg font-bold text-on-surface dark:text-dark-on-surface">Enviando registro...</h1>
          </div>
        }
    </div>
  );
};

export default CameraView;
